import { Link } from 'react-router-dom';

export interface BreadcrumbItem {
  name: string;
  path?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="w-full px-4 md:px-6 py-3">
      <ol className="flex items-center flex-wrap gap-1 text-sm">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={index} className="flex items-center gap-1">
              {index > 0 && (
                <span className="text-foreground-400 mx-1">/</span>
              )}
              {!isLast && item.path ? (
                <Link
                  to={item.path}
                  className="text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer"
                >
                  {item.name}
                </Link>
              ) : (
                <span className={isLast ? 'text-foreground-900 font-medium' : 'text-foreground-500'}>
                  {item.name}
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}